interface MentorSection {
  header: string;
  imageUrl: string;
  title: string;
  description: string;
  buttonText: string;
  tooltip: string;
}

export const sectionCollectiblesHighlights: MentorSection = {
  header: "Highlights",
  imageUrl:
    "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/mentor/highlights.svg",
  title: "Make Every Session Count",
  description:
    "Highlights can contain notes or images to recall valuable information from your 1:1 meetings with your mentor.",
  buttonText: "Create Highlight",
  tooltip: "Save important concepts and notes for easy reference",
};
